import React, { Component } from 'react';
import { Big3Common, bootstrap } from '../../../js/IncludeManager'

/* 개발담당:이재호
 * 화면기능:연령대 선택
 * 세부설명:
*/

export class Age extends Component {
    static displayName = Age.name;

    constructor(props) {
        super(props);
        this.AgeRef = React.createRef();

        this.state = {
            AgeModel: [],
            AgeList: [],
            AgeInfo: { Age_Cd: "", Age_Nm: "" },
        };
        this.handleAgeSelect_Click = this.handleAgeSelect_Click.bind(this);
    }
    //초기화
    componentDidMount() {
    }
    async InitData() {
        try {
            const MstCd = "037";
            const Data = await Big3Common.Get(`api/Common/BaseCode/GetCommonCode/${MstCd}`);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                const DataList = JSON.parse(Data.dataTable);
                this.setState({
                    AgeList: DataList,
                })
            }
        }
        catch (e) {
            console.log("CallAge", e)
        }
    }
    //스타일키워드 선택
    handleAgeSelect_Click(event, dtl_cd, dtl_nm) {
        let AgeList = this.state.AgeModel
        const check = AgeList.some(item => item.Age_Cd === dtl_cd);
        if (AgeList.length < 2 && !check) {
            let AgeInfo = Big3Common.Util.Cloen(this.state.AgeInfo);
            AgeInfo.Age_Cd = dtl_cd;
            AgeInfo.Age_Nm = dtl_nm;
            AgeList.push(AgeInfo);
        }
        else {
            AgeList = AgeList.filter(item => item.Age_Cd !== dtl_cd);
        }
        this.setState({
            AgeModel: AgeList
        })
        event.preventDefault();
    }
    //스타일키워드 등록
    handleSave_Click = async (event) => {
        const AgeModel = this.state.AgeModel;
        this.props.Callback(AgeModel);
        this.handleClose_Click(event);
    }
    handleClose_Click(event) {
        let modalID = this.props.id;
        var modalEl = document.getElementById(modalID);
        var thismodal = bootstrap.Modal.getInstance(modalEl);
        thismodal.hide();
        event.preventDefault();
    }

    Agerender() {
        let AgeList = this.state.AgeList
        let SelectList = this.state.AgeModel;

        if (AgeList.length === 0) {
            return false
        }
        else {
            return (
                <div className="category_select large_Category row row-cols-2">
                    {AgeList.map(list =>
                        <div className={SelectList.some(item => item.Age_Cd === list.dtl_cd) ? "category_item col select" : "category_item col"}
                            key={list.dtl_cd}
                            onClick={(e) => this.handleAgeSelect_Click(e, list.dtl_cd, list.dtl_nm)}
                        >{list.dtl_nm}</div>    
                    )}
                </div>
            )
        }
    }
    
    render() {
        let Agerender = this.Agerender();
        return (
            <div ref={this.AgeRef} id={this.props.id} className="modal fade" tabIndex="-1" data-bs-keyboard="false" data-bs-backdrop={this.props.backdrop === undefined ? "static" : this.props.backdrop}>
                <div className="modal-dialog modal-dialog-centered ">
                    <div className="modal-content">
                        <div className="modal-body style_select">
                            <button type="button" className="modal_in_close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            <div className="modal_title_v2">연령대 등록</div>
                            <div className="Material_wrap">
                                <div className="category_slectbox">
                                    <div className="input_txt">※ 최대 2개 중복선택 가능합니다.</div>
                                    {Agerender}
                                </div>
                            </div>
                            <div className="resister_button_box">
                                <button type="button" className="r_btn_v btn_inactive" data-bs-dismiss="modal" aria-label="Close">취소</button>
                                <button type="button" className="r_btn_v btn_v1" onClick={this.handleSave_Click}>등록</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
